<template>
  <div class="loading-wrapper">
    <div class="loading-animation">
      <lottie :options="options"/>
      <p>{{$t('LOADING_LABEL')}}</p>
    </div>
  </div>
</template>

<script>
import Lottie from '../lottie'
import animationData from './loading.json'

export default {
  components: {
    Lottie
  },
  data () {
    return {
      options: { animationData }
    }
  }
}
</script>

<style lang="scss">
    .loading-wrapper {
    display: block;
  }
  .loading-animation {
    margin: auto;
    text-align: center;

    p {
      opacity: .5;
      height: 0;
    }

  }

  .loading-wrapper {
    padding: $d-large 0 $d-large * 2;
    text-align: center;
  }
  .loading-animation {
    @include shadow(flying);
    display: inline-flex;
    border-radius: 8px;
    background: rgba($color-white, .6);
    width: 180px;
    height: 180px;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
      @include label-x-sml;
      @include deprecated-f-color-dark;
      margin-top: $d-small;
      opacity: .5;
      height: 0;
    }
    svg path {
      stroke:  $deprecated-grey-medium-light;
    }
    div {
      width: $d-med-large;
      height: $d-med-large;
    }
  }
</style>
